import { RegistrationDetailsFormState } from './state/RegistrationDetailsFormState';
import { RegistrationDetailsFormData } from './data/RegistrationDetailsFormData';
import { RegistrationDetailsFormLookups } from './RegistrationDetailsFormLookups';

export class RegistrationDetailsForm {
    data: RegistrationDetailsFormData = new RegistrationDetailsFormData();
    state: RegistrationDetailsFormState = new RegistrationDetailsFormState();
    doValidation: boolean = false;
    lookups: RegistrationDetailsFormLookups = new RegistrationDetailsFormLookups();
}
